import style from "./00_tcp.css";
import Header from "../components/header";
import Footer from "../components/footer";
export default function AccountTerms() {
  return (
    <div style={{ backgroundColor: "#FFFDF4", minHeight: "100vh" }}>
      <Header />
      <div class="legal-document">
        <h1>
          Teacher Listings, Student–Teacher Connections &amp; Safety Policy
        </h1>
        <p class="last-updated">
          <strong>Last Updated:</strong> 24th August 2026
        </p>
        <p>
          This Teacher Listings, Student–Teacher Connections &amp; Safety Policy
          ("Policy") forms part of the Terms and Conditions governing the use of{" "}
          <strong>sursaathi.in</strong> ("Website") operated by{" "}
          <strong>SurSaathi</strong> ("SurSaathi", "we", "us", or "our").
        </p>
        <p>
          This Policy explains the nature and limits of SurSaathi's role in
          connecting music teachers, students, parents, and guardians, and sets
          out important safety responsibilities and precautions that users
          should follow.
        </p>
        <p>
          By registering as a teacher, viewing a teacher listing, requesting
          teacher information, providing your contact details, contacting
          another user, or otherwise using the Website to facilitate a
          teacher–student connection, you acknowledge and agree to this Policy.
        </p>
        <p>---</p>
        <h2>1. Purpose of the Teacher Listing Service</h2>
        <p>
          SurSaathi provides a platform through which music teachers may create
          listings and students or parents/guardians may discover or request
          information about teachers.
        </p>
        <p>
          The purpose of the service is primarily to{" "}
          <strong>facilitate discovery and initial contact</strong> between
          teachers and prospective students or their parents/guardians.
        </p>
        <p>
          SurSaathi is not itself the provider of music lessons unless expressly
          stated otherwise in writing.
        </p>
        <p>
          SurSaathi does not employ teachers merely because they appear on the
          Website and does not act as an agent, representative, partner,
          employer, guardian, supervisor, or legal representative of any teacher
          or student.
        </p>
        <p>---</p>
        <h2>2. Nature of Teacher Listings</h2>
        <p>
          Teacher listings may contain information supplied by the teacher,
          including:
        </p>
        <ul>
          <li>Name;</li>
          <li>Teaching experience;</li>
          <li>Instruments or subjects taught;</li>
          <li>Qualifications or professional information;</li>
          <li>General location;</li>
          <li>Availability;</li>
          <li>Profile photographs;</li>
          <li>Contact information; and</li>
          <li>
            Other information voluntarily provided for the purpose of creating a
            listing.
          </li>
        </ul>
        <p>
          Teachers are responsible for ensuring that the information they submit
          is truthful, accurate, current, lawful, and not misleading.
        </p>
        <p>
          A teacher listing is provided for informational and connection
          purposes only.
        </p>
        <p>
          The presence of a teacher on the Website does <strong>not</strong>{" "}
          mean that SurSaathi:
        </p>
        <ul>
          <li>Has employed the teacher;</li>
          <li>Has certified the teacher;</li>
          <li>Has independently verified every qualification or claim;</li>
          <li>Guarantees the teacher's experience or skill;</li>
          <li>Guarantees the quality of lessons;</li>
          <li>Guarantees the teacher's availability;</li>
          <li>Guarantees the teacher's identity;</li>
          <li>Guarantees the teacher's conduct;</li>
          <li>Guarantees the safety of any meeting or lesson;</li>
          <li>Recommends the teacher for a particular student;</li>
          <li>Guarantees the suitability of the teacher for a student; or</li>
          <li>Guarantees any result from lessons provided by the teacher.</li>
        </ul>
        <p>
          Users must independently evaluate whether a teacher is suitable for
          their particular circumstances.
        </p>
        <p>---</p>
        <h2>3. Verification of Teachers</h2>
        <p>
          SurSaathi may, but is not required to, review information submitted by
          teachers.
        </p>
        <p>
          Where SurSaathi performs any verification, such verification may be
          limited in nature and should not be interpreted as a comprehensive
          background check, professional certification, police verification,
          safeguarding certification, or guarantee of future conduct.
        </p>
        <p>
          Unless expressly stated otherwise on the Website, users should assume
          that teacher information is{" "}
          <strong>user-submitted information</strong> and should independently
          verify information that is important to them.
        </p>
        <p>
          Teachers should provide truthful information and should not submit
          false qualifications, identities, experience, references, photographs,
          or other misleading information.
        </p>
        <p>
          SurSaathi may request additional information, refuse a listing,
          suspend a listing, edit a listing, or remove a listing where we
          consider it appropriate.
        </p>
        <p>---</p>
        <h2>4. How a Student–Teacher Connection Works</h2>
        <p>
          A student or parent/guardian may request information about a teacher
          through the Website.
        </p>
        <p>
          Depending on the circumstances, SurSaathi may provide relevant student
          information to the teacher and/or relevant teacher information to the
          student or parent/guardian for the purpose of facilitating contact.
        </p>
        <p>
          The information shared may include contact details and other
          information reasonably necessary for the requested connection, subject
          to the Privacy Policy and applicable law.
        </p>
        <p>
          The purpose of this process is to enable the parties to contact one
          another directly.
        </p>
        <p>---</p>
        <h2>5. SurSaathi's Role Ends at Facilitation of Contact</h2>
        <p>
          The parties expressly acknowledge that SurSaathi's primary role is to{" "}
          <strong>facilitate discovery and initial communication</strong>{" "}
          between prospective students/parents/guardians and teachers.
        </p>
        <p>
          Once contact details have been provided to the relevant student,
          parent/guardian, or teacher, and the parties are able to communicate
          directly,{" "}
          <strong>
            SurSaathi is not a party to the relationship, arrangement,
            agreement, lesson, transaction, or other dealings between them.
          </strong>
        </p>
        <p>
          Unless SurSaathi expressly agrees otherwise in writing, SurSaathi does
          not:
        </p>
        <ul>
          <li>Arrange or supervise lessons;</li>
          <li>Attend or monitor lessons;</li>
          <li>Employ or manage teachers;</li>
          <li>Set or collect lesson fees;</li>
          <li>Guarantee payment;</li>
          <li>Guarantee attendance;</li>
          <li>Guarantee punctuality;</li>
          <li>Determine lesson locations;</li>
          <li>Control communications between users;</li>
          <li>Control what users say or do;</li>
          <li>Control meetings between users;</li>
          <li>Supervise teachers or students;</li>
          <li>Provide childcare or guardianship;</li>
          <li>Provide security services;</li>
          <li>Conduct ongoing monitoring of users;</li>
          <li>Guarantee the safety of a lesson or meeting;</li>
          <li>Guarantee the quality or outcome of lessons;</li>
          <li>Resolve private disputes between students and teachers; or</li>
          <li>Guarantee that either party will behave appropriately.</li>
        </ul>
        <p>
          Any agreement regarding lessons, fees, schedules, locations, duration,
          cancellation, refunds, teaching methods, transportation, online
          classes, in-person classes, or other arrangements is made directly
          between the relevant parties.
        </p>
        <p>---</p>
        <h2>6. Independent Relationship Between Student and Teacher</h2>
        <p>
          Any relationship that develops between a teacher and a student,
          parent, or guardian after contact is facilitated is an{" "}
          <strong>independent relationship between those parties</strong>.
        </p>
        <p>
          The parties are responsible for discussing and agreeing upon all
          relevant terms before commencing lessons.
        </p>
        <p>These may include:</p>
        <ul>
          <li>Lesson fees;</li>
          <li>Payment method;</li>
          <li>Frequency of lessons;</li>
          <li>Lesson duration;</li>
          <li>Cancellation and rescheduling;</li>
          <li>Trial lessons;</li>
          <li>Online or in-person lessons;</li>
          <li>Lesson location;</li>
          <li>Travel arrangements;</li>
          <li>Instruments and equipment;</li>
          <li>Practice requirements;</li>
          <li>Communication methods;</li>
          <li>Refund arrangements; and</li>
          <li>Any other terms applicable to the teaching relationship.</li>
        </ul>
        <p>
          SurSaathi does not become a contracting party to such an arrangement
          merely because the parties first connected through the Website.
        </p>
        <p>---</p>
        <h1>7. Important Safety Responsibilities</h1>
        <p>
          Users should exercise reasonable care and judgment when communicating
          or meeting with another person introduced through the Website.
        </p>
        <p>
          Users should not assume that because another person appears on the
          Website, that person has been fully verified or is automatically safe
          or suitable.
        </p>
        <p>
          Users should take reasonable steps to protect themselves and others.
        </p>
        <p>---</p>
        <h2>8. Safety Precautions for Students</h2>
        <p>
          Students should consider the following precautions before
          communicating with or meeting a teacher:
        </p>
        <ul>
          <li>
            Verify the teacher's identity and relevant qualifications
            independently.
          </li>
          <li>
            Ask questions about the teacher's experience and teaching methods.
          </li>
          <li>
            Discuss lesson fees and payment arrangements clearly before starting
            lessons.
          </li>
          <li>Avoid sending unnecessary personal or sensitive information.</li>
          <li>
            Do not share passwords, OTPs, banking credentials, government
            identification documents, or other sensitive information.
          </li>
          <li>
            Consider having a parent, guardian, or trusted adult involved in the
            initial communication.
          </li>
          <li>
            For an initial in-person meeting, consider choosing a safe and
            appropriate location.
          </li>
          <li>
            Inform a parent, guardian, family member, or trusted person about
            the meeting.
          </li>
          <li>
            Consider having another responsible adult present where appropriate.
          </li>
          <li>
            Avoid meeting an unfamiliar person alone in an isolated location.
          </li>
          <li>
            Do not agree to transportation arrangements with an unfamiliar
            person without appropriate safeguards.
          </li>
          <li>
            Trust your instincts and discontinue communication if you feel
            uncomfortable or unsafe.
          </li>
          <li>
            Report threatening, abusive, inappropriate, suspicious, or unlawful
            behaviour to the appropriate authorities and, where appropriate, to
            SurSaathi.
          </li>
        </ul>
        <p>
          Students should never feel pressured to continue communicating with or
          taking lessons from a teacher.
        </p>
        <p>---</p>
        <h2>9. Additional Protection for Minors</h2>
        <p>
          Where a student is under 18 years of age, the student's{" "}
          <strong>
            parent or legal guardian should take primary responsibility for
            evaluating and supervising the teacher–student arrangement.
          </strong>
        </p>
        <p>Parents and legal guardians should:</p>
        <ul>
          <li>Review the teacher's information before lessons begin;</li>
          <li>Communicate directly with the teacher where appropriate;</li>
          <li>Verify relevant qualifications and identity information;</li>
          <li>Discuss lesson arrangements and fees;</li>
          <li>Know where and when lessons will take place;</li>
          <li>
            Consider remaining present during in-person lessons involving a
            minor;
          </li>
          <li>
            Use appropriate supervision based on the child's age and
            circumstances;
          </li>
          <li>Ensure that transportation arrangements are safe;</li>
          <li>
            Monitor communications between the child and teacher where
            appropriate;
          </li>
          <li>Establish clear boundaries for communication;</li>
          <li>Take concerns about inappropriate behaviour seriously; and</li>
          <li>
            Take immediate appropriate action if they believe the child is at
            risk.
          </li>
        </ul>
        <p>
          SurSaathi does not act as a parent, guardian, childcare provider,
          chaperone, safeguarding officer, or supervisor for any minor.
        </p>
        <p class="important-notice">
          <strong>
            Parents and legal guardians are responsible for exercising
            appropriate supervision over minors using the Website and entering
            into teaching arrangements with teachers.
          </strong>
        </p>
        <p>
          Nothing in this Policy is intended to transfer or reduce any legal
          duty that a parent, guardian, teacher, institution, or other person
          may have under applicable law.
        </p>
        <p>---</p>
        <h2>10. Safety Precautions for Teachers</h2>
        <p>
          Teachers should also take reasonable precautions when communicating
          with students or parents/guardians.
        </p>
        <p>Teachers should:</p>
        <ul>
          <li>
            Verify the identity and relevant information of prospective students
            or their parents/guardians where appropriate;
          </li>
          <li>Communicate clearly about lesson arrangements;</li>
          <li>
            Establish fees and payment arrangements before commencing lessons;
          </li>
          <li>Avoid requesting unnecessary sensitive personal information;</li>
          <li>Maintain appropriate professional boundaries;</li>
          <li>Exercise additional care when dealing with minors;</li>
          <li>
            Communicate with parents or legal guardians where appropriate;
          </li>
          <li>
            Avoid inappropriate private or personal communications with minors;
          </li>
          <li>Choose safe and appropriate locations for in-person lessons;</li>
          <li>Avoid unsafe or isolated locations;</li>
          <li>
            Inform an appropriate person about unusual or potentially risky
            meetings where necessary;
          </li>
          <li>
            Not engage in threatening, abusive, discriminatory, exploitative, or
            inappropriate behaviour;
          </li>
          <li>
            Not request or pressure students to provide inappropriate
            photographs, videos, personal information, or other material;
          </li>
          <li>Not use student information for unrelated purposes; and</li>
          <li>
            Immediately discontinue an arrangement if they reasonably believe
            there is a safety, fraud, or other serious concern.
          </li>
        </ul>
        <p>
          Teachers are independently responsible for their own professional
          conduct and for complying with laws and regulations applicable to
          their activities.
        </p>
        <p>---</p>
        <h2>11. Professional Boundaries</h2>
        <p>
          Teachers and students are expected to maintain appropriate and
          respectful boundaries.
        </p>
        <p>
          Users must not use the Website or information obtained through the
          Website to:
        </p>
        <ul>
          <li>Harass another person;</li>
          <li>Threaten another person;</li>
          <li>Stalk another person;</li>
          <li>Sexually harass or exploit another person;</li>
          <li>Groom or exploit a minor;</li>
          <li>
            Pressure another person into an unwanted relationship or activity;
          </li>
          <li>Request inappropriate photographs or videos;</li>
          <li>
            Share another person's private information without lawful authority;
          </li>
          <li>Engage in discriminatory abuse;</li>
          <li>Engage in fraud or financial deception; or</li>
          <li>Facilitate any unlawful activity.</li>
        </ul>
        <p>
          Any user who receives inappropriate, threatening, abusive, or
          suspicious communication should discontinue communication where
          appropriate and seek assistance from a parent, guardian, trusted
          person, relevant platform, or appropriate law-enforcement or emergency
          authority.
        </p>
        <p>---</p>
        <h2>12. In-Person Lessons</h2>
        <p>
          If a student and teacher agree to meet in person, they are responsible
          for deciding whether the proposed location and circumstances are safe
          and appropriate.
        </p>
        <p>
          For minors, parents or legal guardians should carefully consider
          whether an adult should remain present during lessons.
        </p>
        <p>
          SurSaathi does not select, inspect, supervise, or guarantee the safety
          of any physical location used for lessons.
        </p>
        <p>
          SurSaathi is not responsible for transportation to or from a lesson
          unless SurSaathi expressly provides a transportation service under
          separate written terms.
        </p>
        <p>---</p>
        <h2>13. Online Lessons</h2>
        <p>
          For online lessons, users are responsible for taking reasonable
          precautions regarding:
        </p>
        <ul>
          <li>The platform used for the lesson;</li>
          <li>Account security;</li>
          <li>Passwords and authentication;</li>
          <li>Screen sharing;</li>
          <li>Recording;</li>
          <li>Camera and microphone access;</li>
          <li>Personal information displayed in the background;</li>
          <li>Links shared during communications; and</li>
          <li>Information exchanged during the lesson.</li>
        </ul>
        <p>
          Users should not share passwords, OTPs, financial credentials, or
          other sensitive authentication information.
        </p>
        <p>
          Teachers and students should respect applicable laws and the privacy
          and consent of other participants when recording or distributing
          lessons.
        </p>
        <p>---</p>
        <h2>14. Payments and Financial Arrangements</h2>
        <p>
          Unless expressly stated otherwise, SurSaathi does not collect or
          process lesson fees between students and teachers.
        </p>
        <p>
          Any payment arrangement is made directly between the relevant parties.
        </p>
        <p>
          Users should independently verify payment details before transferring
          money.
        </p>
        <p>Users should be cautious of requests for:</p>
        <ul>
          <li>Advance payments to unfamiliar accounts;</li>
          <li>Unusual payment methods;</li>
          <li>OTPs or banking credentials;</li>
          <li>Refunds to unrelated accounts;</li>
          <li>Cryptocurrency or other unusual payment requests;</li>
          <li>Payments made on behalf of another person; or</li>
          <li>
            Requests that appear suspicious or inconsistent with the agreed
            arrangement.
          </li>
        </ul>
        <p>
          SurSaathi is not responsible for payment disputes, unpaid fees,
          refunds, chargebacks, financial losses, or fraudulent transactions
          between users, except to the extent liability cannot lawfully be
          excluded.
        </p>
        <p>---</p>
        <h2>15. Personal Information and Contact Details</h2>
        <p>
          Because the purpose of the teacher-listing service is to facilitate
          contact, certain information may be shared between
          students/parents/guardians and teachers.
        </p>
        <p>
          Users should understand that once contact information has been shared,
          the receiving party may be able to contact them directly.
        </p>
        <p>
          Users should therefore avoid submitting unnecessary personal or
          sensitive information.
        </p>
        <p>
          Teachers and students should use personal information obtained through
          SurSaathi only for legitimate purposes connected with the relevant
          enquiry or teaching relationship and should not sell, distribute,
          publish, or misuse another person's personal information.
        </p>
        <p>
          The collection, use, sharing, and retention of personal information by
          SurSaathi is further described in the <strong>Privacy Policy</strong>.
        </p>
        <p>---</p>
        <h2>16. No Guarantee of User Conduct</h2>
        <p>
          SurSaathi cannot guarantee how another user will behave after contact
          details have been provided.
        </p>
        <p>In particular, SurSaathi does not guarantee that a user will:</p>
        <ul>
          <li>Respond;</li>
          <li>Respond politely;</li>
          <li>Honour an agreed arrangement;</li>
          <li>Attend a lesson;</li>
          <li>Pay an agreed amount;</li>
          <li>Provide accurate information;</li>
          <li>Maintain confidentiality;</li>
          <li>Behave professionally;</li>
          <li>Remain available;</li>
          <li>Remain suitable for the student; or</li>
          <li>
            Continue to comply with these policies after leaving the Website.
          </li>
        </ul>
        <p>
          Users are responsible for their own decisions regarding whether and
          how to communicate or proceed with another user.
        </p>
        <p>---</p>
        <h2>17. Disputes Between Students and Teachers</h2>
        <p>
          Any dispute arising directly between a student, parent/guardian, and
          teacher should ordinarily be addressed by the relevant parties.
        </p>
        <p>This may include disputes relating to:</p>
        <ul>
          <li>Fees;</li>
          <li>Refunds;</li>
          <li>Cancellations;</li>
          <li>Lesson quality;</li>
          <li>Attendance;</li>
          <li>Scheduling;</li>
          <li>Conduct;</li>
          <li>Communications;</li>
          <li>Personal disagreements;</li>
          <li>Damage to property;</li>
          <li>Transportation;</li>
          <li>Injuries; or</li>
          <li>Other matters arising from their independent relationship.</li>
        </ul>
        <p>
          SurSaathi is not a party to such private arrangements and does not act
          as an arbitrator, mediator, judge, employer, guardian, or legal
          representative unless we expressly agree to perform a particular role
          in writing.
        </p>
        <p>
          Nothing in this section prevents SurSaathi from taking reasonable
          action concerning use of its Website, including removing a listing,
          restricting access, or suspending a user where appropriate.
        </p>
        <p>---</p>
        <h2>18. Reporting Concerns to SurSaathi</h2>
        <p>
          Users may contact SurSaathi regarding concerns involving the Website
          or a teacher listing.
        </p>
        <p>Reports may include:</p>
        <ul>
          <li>Suspected false qualifications;</li>
          <li>Fake identities;</li>
          <li>Fraudulent activity;</li>
          <li>Harassment;</li>
          <li>Threatening behaviour;</li>
          <li>Inappropriate conduct;</li>
          <li>Suspected exploitation of minors;</li>
          <li>Misuse of personal information;</li>
          <li>Spam;</li>
          <li>Attempts to misuse the Website; or</li>
          <li>Other conduct that may violate our Terms or policies.</li>
        </ul>
        <p>
          Where appropriate, SurSaathi may review the information available to
          it and may take action such as requesting clarification, removing
          content, suspending a listing, restricting access, or terminating a
          user's participation.
        </p>
        <p>
          SurSaathi does not guarantee that every report will result in a
          particular outcome.
        </p>
        <p>
          Where a matter involves an immediate threat to life, physical safety,
          sexual abuse, child protection, or other serious criminal conduct,
          users should contact the appropriate emergency service,
          law-enforcement authority, child-protection authority, or other
          competent authority rather than relying solely on SurSaathi.
        </p>
        <p>---</p>
        <h2>19. Right to Remove or Suspend Teacher Listings</h2>
        <p>SurSaathi may, at its discretion and subject to applicable law:</p>
        <ul>
          <li>Refuse to publish a teacher listing;</li>
          <li>Request additional information;</li>
          <li>Edit or correct information;</li>
          <li>Temporarily suspend a listing;</li>
          <li>Permanently remove a listing;</li>
          <li>Restrict access to the Website;</li>
          <li>Investigate suspected misuse; or</li>
          <li>
            Take other reasonable action where we believe a user or listing may
            create a safety, legal, security, fraud, reputational, or policy
            concern.
          </li>
        </ul>
        <p>
          Removal of a listing does not necessarily mean that SurSaathi has
          determined that a user has committed wrongdoing.
        </p>
        <p>---</p>
        <h2>20. User Responsibility After Contact Details Are Shared</h2>
        <p>
          By requesting or accepting contact information through the Website,
          each user acknowledges that they are responsible for exercising their
          own judgment and appropriate precautions.
        </p>
        <p>
          After contact details have been shared, users are responsible for:
        </p>
        <ul>
          <li>Verifying the identity and suitability of the other party;</li>
          <li>Deciding whether to communicate;</li>
          <li>Deciding whether to meet;</li>
          <li>Deciding whether to commence lessons;</li>
          <li>Agreeing on fees and other arrangements;</li>
          <li>Maintaining appropriate boundaries;</li>
          <li>Protecting their personal information;</li>
          <li>Taking appropriate safety precautions;</li>
          <li>Supervising minors where applicable; and</li>
          <li>Complying with applicable laws.</li>
        </ul>
        <p>
          SurSaathi's facilitation of contact does not constitute a guarantee,
          recommendation, certification, or endorsement of either party.
        </p>
        <p>---</p>
        <h2>21. Disclaimer Regarding User Interactions</h2>
        <p>
          To the maximum extent permitted by applicable law, SurSaathi is not
          responsible for the independent acts, omissions, statements,
          representations, misconduct, negligence, decisions, or behaviour of
          students, parents, guardians, teachers, or other users.
        </p>
        <p>This includes, without limitation, matters arising from:</p>
        <ul>
          <li>Communications;</li>
          <li>Phone calls;</li>
          <li>Messages;</li>
          <li>Emails;</li>
          <li>Online meetings;</li>
          <li>In-person meetings;</li>
          <li>Music lessons;</li>
          <li>Travel;</li>
          <li>Payments;</li>
          <li>Cancellations;</li>
          <li>Property damage;</li>
          <li>Personal injury;</li>
          <li>Loss;</li>
          <li>Theft;</li>
          <li>Fraud;</li>
          <li>Harassment;</li>
          <li>Abuse;</li>
          <li>Misconduct; or</li>
          <li>Any other interaction between users.</li>
        </ul>
        <p>
          This limitation applies particularly to events occurring after
          SurSaathi has facilitated the exchange of relevant contact information
          or otherwise enabled the parties to communicate directly.
        </p>
        <p>
          Nothing in this Policy excludes, restricts, or limits any liability or
          legal right that cannot lawfully be excluded, restricted, or limited
          under applicable law.
        </p>
        <p>---</p>
        <h2>22. No Waiver of Legal Rights</h2>
        <p>Nothing in this Policy is intended to:</p>
        <ul>
          <li>Exclude liability that cannot legally be excluded;</li>
          <li>Remove statutory consumer rights;</li>
          <li>
            Remove rights available under applicable data-protection laws;
          </li>
          <li>Remove legal protections applicable to children or minors;</li>
          <li>
            Prevent a person from reporting unlawful conduct to the appropriate
            authority; or
          </li>
          <li>
            Prevent any lawful claim or remedy that cannot legally be waived.
          </li>
        </ul>
        <p>
          Any limitation of liability in this Policy applies only to the maximum
          extent permitted by applicable law.
        </p>
        <p>---</p>
        <h2>23. User Indemnification</h2>
        <p>
          To the extent permitted by applicable law, a user may be responsible
          for losses, claims, liabilities, damages, costs, or expenses suffered
          by SurSaathi arising from the user's:
        </p>
        <ul>
          <li>Breach of this Policy;</li>
          <li>Breach of the Terms and Conditions;</li>
          <li>False or misleading information;</li>
          <li>Misuse of another person's information;</li>
          <li>Unlawful conduct;</li>
          <li>Fraudulent conduct;</li>
          <li>Violation of another person's rights; or</li>
          <li>
            Use of the Website in a manner that causes harm to SurSaathi or
            another person.
          </li>
        </ul>
        <p>
          This section does not apply to the extent that such responsibility
          cannot lawfully be imposed.
        </p>
        <p>---</p>
        <h2>24. No Professional or Safeguarding Advice</h2>
        <p>
          The information contained in this Policy is intended to provide
          general safety guidance.
        </p>
        <p>
          It does not constitute legal, medical, professional safeguarding,
          security, or child-protection advice.
        </p>
        <p>
          Parents, guardians, teachers, and students should obtain appropriate
          professional advice where their circumstances require it.
        </p>
        <p>---</p>
        <h2>25. Relationship with Other SurSaathi Policies</h2>
        <p>This Policy should be read together with:</p>
        <ol>
          <li>
            <strong>SurSaathi Terms and Conditions</strong>; and
          </li>
          <li>
            <strong>SurSaathi Privacy Policy</strong>.
          </li>
        </ol>
        <p>
          If there is a conflict between this Policy and the Terms and
          Conditions, the Terms and Conditions will apply to the extent of the
          conflict, unless expressly stated otherwise.
        </p>
        <p>
          The Privacy Policy governs the collection, use, disclosure, and
          retention of personal information.
        </p>
        <p>---</p>
        <h2>26. Changes to This Policy</h2>
        <p>SurSaathi may update this Policy from time to time.</p>
        <p>
          The "Last Updated" date at the beginning of this document indicates
          when the Policy was most recently revised.
        </p>
        <p>
          Continued use of the Website after an updated Policy is published
          constitutes acceptance of the updated Policy to the extent permitted
          by applicable law.
        </p>
        <p>---</p>
        <h2>27. Governing Law</h2>
        <p>
          This Policy shall be governed by the laws of <strong>India</strong>,
          subject to applicable mandatory legal rights and jurisdictional
          requirements.
        </p>
        <p>---</p>
        <h2>28. Contact Us</h2>
        <p>
          If you have questions, concerns, or reports relating to teacher
          listings, student–teacher connections, safety, or misuse of the
          Website, please contact:
        </p>
        <p>
          <strong>SurSaathi</strong>
        </p>
        <p>
          Email:{" "}
          <a href="mailto:sursaathi.music@gmail.com">
            <strong>sursaathi.music@gmail.com</strong>
          </a>
        </p>
        <p>
          Website: <strong>sursaathi.in</strong>
        </p>
        <p>---</p>
        <h1>Important Safety Notice</h1>
        <p class="important-notice">
          <strong>
            SurSaathi is a platform intended to help students, parents,
            guardians, and music teachers find and contact one another. A
            teacher listing does not constitute a guarantee, certification,
            endorsement, or background check.
          </strong>
        </p>
        <p class="important-notice">
          <strong>
            Once contact details are shared, students, parents/guardians, and
            teachers are responsible for independently verifying the other
            party, deciding whether to proceed, agreeing to their own
            arrangements, and taking appropriate safety precautions.
          </strong>
        </p>
        <p class="important-notice">
          <strong>
            Parents and legal guardians should remain actively involved in
            arrangements involving minors and should exercise appropriate
            supervision before and during any teacher–student relationship.
          </strong>
        </p>
        <p class="important-notice">
          <strong>
            If you believe that you or another person is in immediate danger, do
            not rely solely on SurSaathi. Contact the appropriate emergency,
            law-enforcement, child-protection, or other competent authority.
          </strong>
        </p>
      </div>
      <Footer />
    </div>
  );
}
